var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("gmap-map", {
    staticStyle: {
      width: "100%",
      height: "100vh"
    },
    attrs: {
      center: _vm.center,
      zoom: 3,
      options: {
        disableDefaultUI: true,
        styles: _vm.snazzy
      }
    }
  }, _vm._l(_vm.markers, function (marker, index) {
    return _c("gmap-marker", {
      key: index,
      attrs: {
        position: marker.position,
        clickable: true,
        draggable: false
      },
      on: {
        click: function click($event) {
          _vm.center = marker.position;
          _vm.emitEvent(marker);
        }
      }
    });
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };